import React from "react";
import {setBranchSkeleton} from "../../../skeleton";
import {withTranslate} from "react-redux-multilingual";
import BranchCard from "../BranchCard";


const BranchList = ({branches, branchesIsLoading, doctor, currentBranch, translate, book}) => {

    const branchesList = branches && branches.length ? branches.map((branch) => {
            return (
                <BranchCard key={branch.id} doctor={doctor} book={(currentBranch) => book(currentBranch)}
                            currentBranch={currentBranch} branch={branch} translate={translate}/>
            )
        }
    ) : <div className="branch">
        <div className="branch-header">
                            <span className="icon">
                                <img src="/images/branch.png" className="money-icon" alt="branch"/>
                            </span>
            {translate("booking_is_not_available")}
        </div>

        <div className="branch-details">
            <p className="text-center bolder red-notation">  {translate("booking_is_not_available")}</p>
        </div>
    </div>;

    return (
       branchesList
    )
};

export default withTranslate(BranchList)